import React, { useMemo } from 'react'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'

export enum AiCoachStatus {
  ENABLED = 'ENABLED',
}

export type ClientFiltersLyraAiSectionProps = {
  values: AiCoachStatus[]
  onChange: (values: AiCoachStatus[]) => void
}

export const ClientFiltersLyraAiSection: React.FC<ClientFiltersLyraAiSectionProps> = ({ values, onChange }) => {
  const filterNames: Record<AiCoachStatus, MessageDescriptor> = useMemo(
    () =>
      defineMessages({
        [AiCoachStatus.ENABLED]: {
          defaultMessage: 'Enabled',
          description: 'Label for filtering client list by lyra AI enabled',
        },
      }),
    [],
  )

  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Lyra AI' description='Lyra AI status filter section' />}
      items={Object.values(AiCoachStatus).map((value) => ({
        id: value,
        text: <FormattedMessage {...filterNames[value]} />,
      }))}
      values={values}
      onChange={onChange}
      name='aiCoachStatus'
    />
  )
}
